import { useParams } from "react-router-dom";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import CadastraEEditaProduto from "../CadastraEEditaProduto";
interface IRouteParams {
    idProduto: string;
}

export default function EditarProduto() {
    const { value: lstEmpreendimentos, execute: listarEmpreendimentos } =
        useAsyncEffect(ListarEmpreendimentosController);
    const params = useParams<IRouteParams>();

    return (
        <>
            <CadastraEEditaProduto
                updateList={listarEmpreendimentos}
                editando={true}
                row={lstEmpreendimentos?.find(
                    (lst) => lst.ID_EMPREENDIMENTO === Number(params.idProduto)
                )}
            />
        </>
    );
}
